export default __webpack_public_path__ + "static/media/Pic13.72d0e754.jpg";